export const APP_NEED_RELOAD = 'APP_NEED_RELOAD';

export const setNeedReload = (status) => {
  return {
    type: APP_NEED_RELOAD,
    needReload: status
  };
};
